// @flow

import _ from 'lodash';
import ApiObject from '../ApiObject';
import ArrayUtils from '../../utils/ArrayUtils';
import Order from './Order';

class Filter {
  static STATUS_NOT_READY = 0;
  static STATUS_READY = 1;
  static ON_GOING = 2;
  static NOT_ON_GOING = 3;
  static HISTORY = 4;
}

export default class OrdersList extends ApiObject {

  orders: Array<Order> = []; // Array of Order

  /**
   * Front only. See OrdersListStore.
   * Set to true if the ajax api request retrieved new orders to take care.
   */
  haveNewOrders = false;

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.orders = [];

    // -- handle the case were the api responds a json with the array directly.
    let dataOrders = [];
    if (!_.isUndefined(data.orders)) { // old format, maybe not used anymore
      dataOrders = data.orders;
    } else if (!_.isUndefined(data.data)) { // paginated data
      dataOrders = data.data;
    } else {
      dataOrders = data;
    }

    _.each(dataOrders, (orderData: Object) => {
      const order: Order = new Order();
      order.fromJson(orderData);

      this.orders.push(order);
    });
  }

  addOrder(orderToAdd: Order) {
    this.orders.push(orderToAdd);
  }

  updateOrder(orderToUpdate: Order) {
    this.orders = ArrayUtils.updateObject(this.orders, orderToUpdate, { id: orderToUpdate.id });
  }

  getOrdersReady(): Array<Order> {
    return this.getOrdersWithFilters(Filter.STATUS_READY);
  }

  getOrdersNotReady(): Array<Order> {
    return this.getOrdersWithFilters(Filter.STATUS_NOT_READY);
  }

  getOnGoingOrders(): Array<Order> {
    return this.getOrdersWithFilters(Filter.ON_GOING);
  }

  getNotOnGoingOrders(): Array<Order> {
    return this.getOrdersWithFilters(Filter.NOT_ON_GOING);
  }

  getHistoryOrders() {
    return this.getOrdersWithFilters(Filter.HISTORY);
  }

  /**
   * @param filter the Filter
   */
  getOrdersWithFilters(filter: number): Array<Order> {
    const results = [];

    _.each(this.orders, (order: Order) => {

      if (filter === Filter.STATUS_READY && order.isReady()) {
        results.push(order);
      } else if (filter === Filter.STATUS_NOT_READY && order.isNotReady()) {
        results.push(order);
      } else if (filter === Filter.ON_GOING && order.isOnGoing()) {
        results.push(order);
      } else if (filter === Filter.NOT_ON_GOING && !order.isOnGoing()) {
        results.push(order);
      } else if (filter === Filter.HISTORY && order.isForHistory()) {
        results.push(order);
      }
    });

    return results;
  }

  isEmpty(): boolean {
    return _.isEmpty(this.orders);
  }

  getLastUpdateOrder(): Order {
    let lastUpdateOrder: Order = null;
    _.each(this.orders, (order: Order) => {
      if (_.isNull(lastUpdateOrder) || order.modificationDate.isAfter(lastUpdateOrder.modificationDate)) {
        lastUpdateOrder = order;
      }
    });

    return lastUpdateOrder;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/OrdersList.js